export default __webpack_public_path__ + "static/kampagne-vivawest-6156dba2936fd940f557890d4e5928ad.jpg";